// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favorite-restaurant-text {
  margin-top: 130px;
}

.no-favorite-container {
  text-align: center;
  max-width: 25%;
  margin: 65px auto;
}

.favorite-restaurant-button {
  padding: 14px;
  background-color: var(--primary);
  text-decoration: none;
  color: white;
  border-radius: 5px;
  min-width: 44px;
  min-height: 44px;
  display: inline-block;
  margin-top: 30px;
}

/* Loading and Error */
.loading-indicator {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-message {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5em;
  color: red;
}

/* End Loading and Error */

@media screen and (max-width: 635px) {
  .favorite-restaurant-text {
    margin-top: 150px;
    font-size: 1.4rem;
  }

  .no-favorite-container {
    max-width: 80%;
  }

  .no-favorite-container p {
    font-size: 0.9rem;
  }

  .no-favorite-container a {
    font-size: 0.9rem;
  }
}

@media screen and (min-width: 636px) and (max-width: 1023px) {
  .no-favorite-container {
    max-width: 40%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/favorite-restaurant.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B,EAAE,eAAe;EAC3C,8BAA8B,EAAE,SAAS;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,0BAA0B;;AAE1B;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".favorite-restaurant-text {\n  margin-top: 130px;\n}\n\n.no-favorite-container {\n  text-align: center;\n  max-width: 25%;\n  margin: 65px auto;\n}\n\n.favorite-restaurant-button {\n  padding: 14px;\n  background-color: var(--primary);\n  text-decoration: none;\n  color: white;\n  border-radius: 5px;\n  min-width: 44px;\n  min-height: 44px;\n  display: inline-block;\n  margin-top: 30px;\n}\n\n/* Loading and Error */\n.loading-indicator {\n  border: 16px solid #f3f3f3; /* Light grey */\n  border-top: 16px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.error-message {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5em;\n  color: red;\n}\n\n/* End Loading and Error */\n\n@media screen and (max-width: 635px) {\n  .favorite-restaurant-text {\n    margin-top: 150px;\n    font-size: 1.4rem;\n  }\n\n  .no-favorite-container {\n    max-width: 80%;\n  }\n\n  .no-favorite-container p {\n    font-size: 0.9rem;\n  }\n\n  .no-favorite-container a {\n    font-size: 0.9rem;\n  }\n}\n\n@media screen and (min-width: 636px) and (max-width: 1023px) {\n  .no-favorite-container {\n    max-width: 40%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
